import type { DashboardSession, DashboardSessionResponse } from './types';

export const AGENT_DASHBOARD_SESSION_STORAGE_KEY = 'agent-dashboard-session';
export const CLAUDE_CODE_SESSION_STORAGE_KEY = 'claude-code-session';

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const isDashboardSession = (value: unknown): value is DashboardSession => {
  if (!isObject(value)) {
    return false;
  }

  return (
    typeof value['employeeId'] === 'string' &&
    typeof value['email'] === 'string' &&
    typeof value['expiresAt'] === 'string' &&
    typeof value['isAdmin'] === 'boolean'
  );
};

export const normalizeDashboardSession = (value: unknown): DashboardSession | null => {
  if (isDashboardSession(value)) {
    return value;
  }

  if (!isObject(value)) {
    return null;
  }

  const response = value as Partial<DashboardSessionResponse>;
  return isDashboardSession(response.session) ? response.session : null;
};
